import {
  AccountBalanceOutlined,
  AssessmentOutlined,
  Business,
  ChatBubbleOutlineOutlined,
  DescriptionOutlined,
  FilterTiltShiftOutlined,
  FolderOutlined,
  GroupsOutlined,
  HandshakeOutlined,
  HubOutlined,
  InboxOutlined,
  InsertDriveFileOutlined,
  InterestsOutlined,
  InventoryOutlined,
  LibraryBooksOutlined,
  LocationOnOutlined,
  Logout,
  MonetizationOnOutlined,
  PolicyOutlined,
  PolylineOutlined,
  SettingsOutlined,
  ShoppingBagOutlined,
  ShoppingCartOutlined,
  SpaceDashboardOutlined,
  StraightenOutlined,
  SupervisedUserCircleOutlined,
  TrainOutlined,
  WidgetsOutlined,
  WorkOutlineOutlined,
} from '@mui/icons-material';
import { SvgIconProps } from '@mui/material';
import { ComponentType } from 'react';

import {
  BaseDetailDomainType,
  BaseDomainType,
  Domain,
  IntakeDomainType,
  KnowledgeGraphDomainType,
  KnowledgeRepositoryDomainType,
  NegotiationDomainType,
  RuleDomainType,
  TenantDomainType,
  UserDomainType,
  DataAccessManagementDomainType,
} from '~/common/types';

const iconMap: Record<Domain, ComponentType<SvgIconProps>> = {
  [BaseDomainType.GENERAL]: SpaceDashboardOutlined,
  [BaseDomainType.SUPPLIER]: Business,
  [BaseDomainType.COMPANY]: Business,
  [BaseDomainType.CONTRACT]: InsertDriveFileOutlined,
  [BaseDomainType.ORDER]: ShoppingCartOutlined,
  [BaseDomainType.COMMODITY]: WidgetsOutlined,
  [BaseDomainType.COMMODITY_GROUP]: WidgetsOutlined,
  [BaseDomainType.PURCHASE_REQUISITION]: InsertDriveFileOutlined,
  [BaseDomainType.SETTINGS]: SettingsOutlined,
  [BaseDomainType.INTERNAL_TOOLS]: InterestsOutlined,
  [BaseDomainType.DATA_FOUNDATION]: PolylineOutlined,
  [BaseDomainType.SOURCING_PROJECT]: LibraryBooksOutlined,
  [BaseDetailDomainType.CONTRACT_DETAILS]: InsertDriveFileOutlined,
  [BaseDetailDomainType.PURCHASE_ORDER_DETAILS]: ShoppingCartOutlined,
  [BaseDetailDomainType.PURCHASE_REQUISITION_DETAILS]: InsertDriveFileOutlined,
  [BaseDetailDomainType.PURCHASE_ORDER_ITEM_DETAILS]: ShoppingCartOutlined,
  [BaseDetailDomainType.SOURCING_PROJECT_DETAILS]: LibraryBooksOutlined,
  [BaseDetailDomainType.COVERAGE_ASSISTANT]: AssessmentOutlined,
  [NegotiationDomainType.CASE]: InsertDriveFileOutlined,
  [NegotiationDomainType.DEMAND]: ShoppingBagOutlined,
  [NegotiationDomainType.DEMAND_CASES]: ShoppingBagOutlined,
  [NegotiationDomainType.CONTRACT_DEMAND]: InsertDriveFileOutlined,
  [NegotiationDomainType.CONTRACT_DEMAND_REQUEST]: InsertDriveFileOutlined,
  [NegotiationDomainType.CONTRACT_DEMAND_CASES]: ShoppingBagOutlined,
  [NegotiationDomainType.NEGOTIATION_CASE]: HandshakeOutlined,
  [NegotiationDomainType.SOURCING_CASE_QUOTE]: HandshakeOutlined,
  [IntakeDomainType.INTAKE]: ChatBubbleOutlineOutlined,
  [KnowledgeGraphDomainType.KNOWLEDGE_GRAPH]: HubOutlined,
  [UserDomainType.USER_AVAILABILITY]: SupervisedUserCircleOutlined,
  [UserDomainType.SIGN_OUT]: Logout,
  [RuleDomainType.RULE_SOURCING]: FilterTiltShiftOutlined,
  [KnowledgeRepositoryDomainType.PROCUREMENT_KNOWLEDGE]: PolicyOutlined,
  [TenantDomainType.PURCHASE_ORDER]: ShoppingCartOutlined,
  [TenantDomainType.ORDER_CONFIRMATION]: InventoryOutlined,
  [TenantDomainType.DOCUMENT]: DescriptionOutlined,
  [TenantDomainType.EMAIL]: InboxOutlined,
  [TenantDomainType.COMPANY_LIST]: Business,
  [TenantDomainType.LOCATION_LIST]: LocationOnOutlined,
  [TenantDomainType.SAVINGS_LIST]: MonetizationOnOutlined,
  [TenantDomainType.COMMODITY_GROUP_LIST]: WidgetsOutlined,
  [TenantDomainType.DEMAND_PROJECT_LIST]: FolderOutlined,
  [TenantDomainType.COMMODITY_LIST]: WidgetsOutlined,
  [TenantDomainType.GL_ACCOUNT_LIST]: AccountBalanceOutlined,
  [TenantDomainType.ACCOUNTING_DETAILS_LIST]: AccountBalanceOutlined,
  [TenantDomainType.ACCOUNTING_ASSET_LIST]: TrainOutlined,
  [TenantDomainType.UNIT_LIST]: StraightenOutlined,
  [TenantDomainType.WORK_PACKAGE_LIST]: WorkOutlineOutlined,
  [TenantDomainType.INTERNAL_ORDER_LIST]: AccountBalanceOutlined,
  [TenantDomainType.ORGANIZATIONAL_UNIT]: Business,
  [DataAccessManagementDomainType.TEAMS_MANAGEMENT]: GroupsOutlined,
};

export interface IconProps extends SvgIconProps {
  domain: Domain;
}

export const DomainIcon = ({ domain, ...props }: IconProps) => {
  const IconComponent = iconMap[domain];
  return IconComponent ? <IconComponent fontSize="small" {...props} /> : null;
};
